const moment = require('moment');
import * as constAction from 'root/actionConstants';

export const get = () => ({
  type: constAction.FERIADOS_GET,
  payload: {
    filter: {
      where: {
        and: [
          {
            fecha: {
              lte: moment().endOf('year').toDate().getTime()
            }
          },
          {
            fecha: {
              gte: moment().startOf('day').toDate().getTime()
            }
          }
        ]
      },
      'order': 'fecha'
    }
  },
  epic: {
    url: 'feriados',
    method: 'GET'
  }
});

export const setState = ( state ) => ({
  type: constAction.FERIADOS_SET_STATE,
  payload: state
});

export const set = ( fecha ) => ({
  type: constAction.FERIADOS_SET,
  payload:{
    fecha
  },
  epic: {
    url: 'feriados',
    method: 'POST'
  }
});

export const setStateById = ( result ) => ({
  type: constAction.FERIADOS_SET_STATE_BY_ID,
  payload: result
});

export const delete_ = ( id ) => ({
  type: constAction.FERIADOS_DELETE,
  payload: id,
  epic: {
    url: 'feriados/'+id,
    method: 'DELETE'
  }
});



// WEBPACK FOOTER //
// src/modules/feriados/action.js